import { Injectable } from "@angular/core";

export enum ApplicationRoles {
  DevAdmin = 0,
  BB_Coach = 1,
  BB_BranchAdmin = 2,
  BB_DataAnalysis = 3,
  BB_MaterialManagement = 4,
  BB_ProvincialSupport = 5,
  BB_DivisionProgramLead = 6,
  BB_CoachedParticipant = 7,
  BB_SelfGuidedParticipant = 8,
  LLTTF_CoachedParticipant = 9,
  LLTTF_OrganizationAdmin = 10,
  LLTTF_Facilitator = 11,
  LLTTF_DivisionProgramLead = 12,
  BB_SuperAdmin = 13,
  LLTTF_SuperAdmin = 14,
  BB_DataAnalysisBC = 15
}

@Injectable({
  providedIn: 'root'
})

export class ApplicationRolesEnumDescriptionService {
  private descriptions: { [key: number]: string } = {
    [ApplicationRoles.DevAdmin]: "Devadmin",
    [ApplicationRoles.BB_Coach]: "BounceBack Coach",
    [ApplicationRoles.BB_BranchAdmin]: "BounceBack Branch Admin",
    [ApplicationRoles.BB_DataAnalysis]: "BounceBack Data Analysis",
    [ApplicationRoles.BB_MaterialManagement]: "BounceBack Material Management",
    [ApplicationRoles.BB_ProvincialSupport]: "BounceBack Provincial Support",
    [ApplicationRoles.BB_DivisionProgramLead]: "BounceBack Division Program Lead",
    [ApplicationRoles.BB_CoachedParticipant]: "BounceBack Coached Participant",
    [ApplicationRoles.BB_SelfGuidedParticipant]: "BounceBack Self-Guided Participant",
    [ApplicationRoles.LLTTF_CoachedParticipant]: "Living Life to the Full Coached Participant",
    [ApplicationRoles.LLTTF_OrganizationAdmin]: "Living Life To The Full Organization Admin",
    [ApplicationRoles.LLTTF_Facilitator]: "Living Life to the Full Facilitator",
    [ApplicationRoles.LLTTF_DivisionProgramLead]: "Living Life to the Full Division Program Lead",
    [ApplicationRoles.BB_SuperAdmin]: "BB Superadmin",
    [ApplicationRoles.LLTTF_SuperAdmin]: "LLTTF Superadmin",
    [ApplicationRoles.BB_DataAnalysisBC]: "BounceBack Data Analysis BC"
  };

  getDescription(enumValue: number): string {
    return this.descriptions[enumValue] || 'Unknown';
  }
}